/**
 * 站点品牌常量
 * 统一维护前台、后台与 API 的品牌展示文案
 */

export const SITE_BRAND_NAME = '造梦阁';
export const SITE_FULL_NAME = '造梦阁';
export const SITE_TITLE_SUFFIX = '造梦阁';
export const ADMIN_TITLE_SUFFIX = '造梦阁管理后台';
export const ADMIN_FULL_NAME = '造梦阁管理后台';
export const API_DISPLAY_NAME = '造梦阁 API';
export const API_DESCRIPTION = '基于人工智能技术的漫剧自动化创作工具 API 文档';

export const DEFAULT_SEO = {
  title: SITE_FULL_NAME,
  description: `${SITE_FULL_NAME} - 基于人工智能技术的视频自动化创作工具`,
  keywords: 'AI,漫剧创作,人工智能,视频生成,分镜,配音',
} as const;

export function buildDocumentTitle(pageTitle?: string, isAdminRoute = false) {
  const suffix = isAdminRoute ? ADMIN_TITLE_SUFFIX : SITE_TITLE_SUFFIX;
  return pageTitle ? `${pageTitle} - ${suffix}` : suffix;
}
